export default __webpack_public_path__ + "static/media/zamora.049fa3aa.webp";